import Model from './BaseModel'
import i18n from '@/plugins/i18n'

export default class Setting extends Model {
    resourceName() {
        return 'settings'
    }

    fields() {
        return ['slug', 'name', 'value', 'created_at', 'updated_at']
    }

    computed() {
        return {
            readableName(setting) {
                return `${setting.name}`
            },
        }
    }

    get tableColumns() {
        return [
            {
                text: i18n.t('resources.settings.attributes.slug'),
                value: 'slug',
            },
            {
                text: i18n.t('resources.settings.attributes.name'),
                value: 'name',
            },
            {
                text: i18n.t('resources.settings.attributes.value'),
                value: 'value',
            },
            {
                text: i18n.t('tables.actions'),
                value: 'action',
                sortable: false,
                align: 'end',
            },
        ]
    }
}
